export const BIOCHAR_REMOVAL_ID = 8400;
export const BLUE_CARBON_REMOVAL_ID = 8843;
export const ARR_REMOVAL_ID = 8832;
export const REGENERATIVE_AGRICULTURE_REMOVAL_ID = 11296;

export const CAPTURE_AVOIDANCE_ID = 9938;
export const COMMUNITY_AVOIDANCE_ID = 6709;
export const FORESTRY_AVOIDANCE_ID = 9160;
export const WETLANDS_AVOIDANCE_ID = 3144;
export const SUPPORT_NATURE_PROJECT_ID = 11260;
export const GENERAL_AVOIDANCE_ID = 10892;

export const REFORESTATION_ID = 1401;

export const INACTIVE_PROJECT_ID = 6068;

export const TREE_PRICE = 60;

export const CAPTURE_PRICE = 945;
export const COMMUNITY_PRICE = 1180;
export const FORESTRY_PRICE = 1360;
export const WETLANDS_PRICE = 1360;

export const CAPTURE_SDGs = [2, 7, 13];

export const BIOCHAR_SDGs = [13, 15];

export const HABITAT_RESTORATION_SDGs = [13, 15];
